import axios from 'axios'
import { apiConfigAuthenticated } from '@/api/config'

export let apiGetRedirects = function (token) {
  return axios.get(`/api/v0/statistic/objects-redirect/`,
    apiConfigAuthenticated(token))
}

export let apiCreateRedirect = function (data, token) {
  return axios.post(`/api/v0/statistic/objects-redirect/`,
    data,
    apiConfigAuthenticated(token))
}

export let apiUpdateRedirect = function (data, token) {
  return axios.put(`/api/v0/statistic/objects-redirect/`,
    data,
    apiConfigAuthenticated(token))
}

export let apiRedirectDelete = function (data, token) {
  return fetch(`${process.env.SH_SERVER}/api/v0/statistic/objects-redirect/`, {
    method: 'DELETE',
    body: data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    responseType: 'json',
    withCredentials: true
  })
}



// WEBPACK FOOTER //
// ./src/api/redirect.js